var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6645 10.3355H10.3318C9.41278 10.3355 8.66542 11.0829 8.66542 12.0019V15.3346C8.66542 16.2536 9.41278 17.0009 10.3318 17.0009H13.6645C14.5835 17.0009 15.3308 16.2536 15.3308 15.3346V12.0019C15.3308 11.0829 14.5835 10.3355 13.6645 10.3355ZM10.3318 15.3346V12.0019H13.6645V15.3346H10.3318ZM20.3299 6.77286V3.6701C20.3299 3.20936 19.9566 2.83693 19.4967 2.83693C19.0368 2.83693 18.6635 3.20936 18.6635 3.6701V5.64223L14.3285 2.71612C12.913 1.76129 11.0833 1.76129 9.66773 2.71612L3.83632 6.65204C2.68654 7.42773 2 8.71749 2 10.1056V17.8341C2 20.1312 3.86882 22 6.16589 22H17.8304C20.1274 22 21.9963 20.1312 21.9963 17.8341V10.1056C21.9963 8.78831 21.3764 7.55687 20.3299 6.77286ZM20.3299 17.8341C20.3299 19.2122 19.2084 20.3336 17.8304 20.3336H6.16589C4.78781 20.3336 3.66635 19.2122 3.66635 17.8341V10.1056C3.66635 9.27322 4.07794 8.4992 4.76781 8.03429L10.6001 4.09836C11.025 3.81091 11.5115 3.6676 11.9981 3.6676C12.4847 3.6676 12.9713 3.81091 13.3962 4.09836L19.2284 8.03429C19.9183 8.50003 20.3299 9.27322 20.3299 10.1056V17.8341Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.f7abf970c8c289da8907424c8c11f3e9.svg";
export { ForwardRef as ReactComponent };